<h3>
  <ng-content />
</h3>
<plugins-shared-button
  size="sm"
  variant="secondary-text"
  [ariaLabel]="closeLabel ?? ('dialog.close' | translate)"
  [title]="closeLabel ?? ('dialog.close' | translate)"
  (clicked)="dialogRef.close()"
>
  <icon-cancel />
</plugins-shared-button>
